<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div class="evaluate" v-else>
      <b-container fluid>
        <br />
        <b-row>
          <b-col md="12">
            <div class="loading" v-if="StudentExamSheet">
              <load-data></load-data>
            </div>
            <div v-else>
              <!-- <div v-if="studentSheet.length != 0"> -->
              <div>
                <div class="closeBtn mb-2 text-right">
                  <b-button variant="danger" size="sm" @click="closeCurrentTab()">Close</b-button>
                </div>
                <h4 class="text-center" style="font-size: 24px; font-weight: 900">
                  Evaluation Sheet for: <span class="text-info">{{ exam.name }}</span>
                  <br>
                  <span v-if="participant.absent_enable == 1">
                    <span class="text-danger">The student was absent.</span> <br>
                    <span>Total Score: AB</span>
                  </span>

                  <div v-else-if="scoreNotUpdated" class="text-danger">Exam score is not updated yet, please check back
                    later.</div>
                  <span v-if="showTotalScore"> Total score : {{ totalScore }}/{{ maxScore }}</span>
                  <br>
                  <span v-if="showTotalScore"> {{ (Math.floor(totalScore * 10000 / maxScore) / 100) }} %</span>
                </h4>
                <!-- <div v-if="exam.offline_activity == 0">
                <div class="studentSheet mt-3" v-for="(sheet, sheetIndex) in studentSheet" :key="sheetIndex">
                  <b-card header-tag="header" class="mt-3" footer-tag="footer">
                    <template #header>
                      <div class="question">
                        <p>Ques: {{ sheet.question }} <span v-if="(sheet.maximum_mark > 0)">(Score:
                            {{ sheet.maximum_mark }})</span></p>
                      </div>
                      <span class="text-secondary" v-if="sheet.orquestion_group_id">
                        {{ orquestiongroups[sheet.orquestion_group_id].summary }}: Answer any {{
                            orquestiongroups[sheet.orquestion_group_id].best_of_questions
                        }}
                        (Score: {{ orquestiongroups[sheet.orquestion_group_id].maximum_mark_of_question }})
                      </span>
                    </template>
<b-card-body>
  <div class="answer d-flex justify-content-between align-items-baseline">
    <div class="ans">
      <p v-if="(sheet.answer != null)">Ans: {{ sheet.answer }}</p>
      <p v-if="(sheet.choice_id)">Choice: <span
          :style="sheet.choices[sheet.choice_id].is_right_choice == 1 ? 'color:green;' : 'color:red;'">
          {{ sheet.choices[sheet.choice_id].name }}</span></p>
    </div>
    <div class="marks">
      <p>{{ sheet.marks }}</p>
    </div>
  </div>
  <hr />
  <div class="d-flex justify-content-between flex-wrap">
    <div class="questionAttachments" v-if="sheet.files.length != 0">
      <p>Question Attachments:</p>
      <div class="attachments" v-for="(file, fileIndex) in sheet.files" :key="fileIndex">
        <a :href="userAttachments + file.file_path + file.file_name" class="text-decoration-none" target="_blank"
          style="font-size: 16px">
          {{ file.file_name }}
        </a>
      </div>
    </div>
    <div class="answerAttachments" v-if="sheet.studentFiles.length != 0">
      <p>Answers Attachments:</p>
      <div class="attachments" v-for="(file, fileIndex) in sheet.studentFiles" :key="fileIndex">
        <a :href="userAttachments + file.file_path + file.file_name" class="text-decoration-none" target="_blank"
          style="font-size: 16px">
          {{ file.file_name }}
        </a>
      </div>
    </div>
  </div>
</b-card-body>
</b-card>
</div>
</div> -->

                <!-- <div v-if="exam.offline_activity == 1">
                <div class="studentSheet mt-3">
                  <b-card header-tag="header" class="mt-3" footer-tag="footer">
                    <b-card-body>
                      <div class="answer d-flex justify-content-between align-items-baseline" v-for="(sheet, sheetIndex) in studentSheet" :key="sheetIndex">
                        <div class="question" v-if="!mainQnIds.includes(sheet.questionId)">
                          <p>{{ sheet.questionNumber }} )<span v-if="(sheet.maximum_mark > 0)">
                              {{ sheet.marks }} / {{ sheet.maximum_mark }}</span></p>
                        </div>
                      </div>
                      <hr />
                    </b-card-body>
                  </b-card>
                </div>
              </div> -->
              </div>
              <!-- <div class="markingNotDoneYet" v-else>
                <br />
                <h4 class="text-danger text-center">Marks not alloted yet!</h4>
              </div> -->
            </div>

            <div v-if="enableCoScoreView">
              <br><br>
              <div> </div>
              <table class="coScore-table">
                <thead>
                  <tr>
                    <th>CO</th>
                    <th>Description</th>
                    <th>Score for CO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(co, coIndex) in courseOutcomes" :key="coIndex">
                    <th>
                      {{ co.code }}
                    </th>
                    <td>{{ co.outcome }}</td>
                    <td
                      v-if="(participant.courseoutcomes_score.hasOwnProperty(co.id) && exam.max_co_scores.hasOwnProperty(co.id))">
                      {{ participant.courseoutcomes_score[co.id] }}/{{ exam.max_co_scores[co.id] }}
                    </td>
                    <td v-else></td>
                  </tr>
                  <tr>
                    <td colspan="2">Total</td>
                    <td>{{ totalCoScore }}/{{ maxCoScore }}</td>
                  </tr>
                  <tr>
                    <td colspan="2">%</td>
                    <td>{{ (Math.round(totalCoScore * 1000 / maxCoScore) / 10) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  created() {
    this.fetchData = true;
    this.getExam();
    this.getParticipantCoScore();
    this.userAttachments = this.$store.getters.getAPIKey.userAttachments;

  },
  data() {
    return {
      fetchData: false,
      StudentExamSheet: false,
      answers: {},
      participantabsentstatus: "",
      totalScore: 0,
      maxScore: 0,
      userAttachments: "",
      currentMark: "0",
      exam: {},
      students: [],
      examQuestions: [],
      orquestiongroups: {},
      orGroupScores: {},
      studentSheet: [],
      marksBtn: {
        text: "Submit",
        disabled: false,
      },
      enableCoScoreView: false,
      courseOutcomes: [],
      participant: null,
      totalCoScore: 0,
      maxCoScore: 0,
      scoreNotUpdated: false,
      mainQnIds: [],
    };
  },
  computed: {
    isTotalMark() {
      return Number(this.exam.co_score_evaluation) === 2;
    },
    showTotalScore() {
      if (!this.maxScore || this.scoreNotUpdated) return false;
      return !this.participant || this.participant.absent_enable != 1;
    },
  },
  methods: {
    getExam() {
      const examId = this.$route.params.exam_id;
      const url = this.$store.getters.getAPIKey.examination + `/${examId}`;

      axios
        .get(url)
        .then(async (response) => {
          this.exam = {};
          this.exam = response.data;
          if (this.isTotalMark) {
            await this.getTotalMarkScore();
            return;
          }
          this.getExamQuestions();
          //   this.getCourse();
          response;
        })
        .catch((error) => {
          error;
        });
    },

    // total mark entry keeps one total per student on the participant, out of exam.maximum_mark
    async getTotalMarkScore() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/exams/${this.$route.params.exam_id}/examparticipant`;
      await axios
        .get(url)
        .then((response) => {
          this.participant = response.data;
        })
        .catch((error) => {
          error;
        });
      this.totalScore = 0;
      this.maxScore = Number(this.exam.maximum_mark) || 0;
      if (this.participant && this.participant.absent_enable != 1) {
        if (this.participant.score != null) this.totalScore = Number(this.participant.score);
        this.scoreNotUpdated = this.participant.score == null;
      } else if (!this.participant) {
        this.scoreNotUpdated = true;
      }
      this.fetchData = false;
    },

    async getCourseOutcomes() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/course/${this.exam.course[0].id}/courseoutcomes`;
      await axios
        .get(url)
        .then((response) => {
          this.courseOutcomes = response.data;
          this.totalCoScore = 0;
          this.maxCoScore = 0;
          this.courseOutcomes.forEach(co => {
            this.totalCoScore += Number(this.participant.courseoutcomes_score[co.id]) || 0;
            this.maxCoScore += Number(this.exam.max_co_scores[co.id]) || 0;
          });
        })
        .catch((error) => {
          error;
        });
    },

    async getParticipantCoScore() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/exams/${this.$route.params.exam_id}/examparticipant`;
      await axios
        .get(url)
        .then((response) => {
          this.participant = response.data;
          // a total mark entry score is kept on the participant itself, CO wise scores in courseoutcomes_score
          const hasCoScore = this.participant && this.participant.courseoutcomes_score &&
            Object.values(this.participant.courseoutcomes_score).some(s => s !== null && s !== '');
          if (!this.participant || (this.participant.absent_enable != 1 && this.participant.score == null && !hasCoScore)) {
            this.scoreNotUpdated = true;
          } else if (hasCoScore) {
            this.scoreNotUpdated = false;
          }
        })
        .catch((error) => {
          error;
        });
      if (this.participant && this.participant.courseoutcomes_score) {
        await this.getCourseOutcomes();
        this.enableCoScoreView = true;
      }
    },

    async getOrquestionGroups() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/examorquestiongroups?exam_id=${this.exam.id}`;
      let orquestiongroups = await this.$axios.get(url).then((response) => {
        return response.data;
      });
      this.orquestiongroups = {};
      // this.orGroupQuestionIds = {}; // initiate
      await orquestiongroups.forEach((group) => {
        // this.orGroupQuestionIds[group.id] = [];
        this.orquestiongroups[group.id] = group;
        this.orGroupScores[group.id] = [];
      });

    },

    getStudentSheet() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/exams/${this.exam.id}/institutionuser/examanswers`;
      axios
        .get(url)
        .then((response) => {


          this.answers = response.data;

          this.answers.forEach((ans) => {
            if (ans.score != null) {
              this.scoreNotUpdated = false;
            }
          });

          let orQgroupIds = [];
          this.totalScore = 0;

          // Helper: get score from this.answers using questionId
          const getScore = (questionId) => {
            const ans = this.answers.find(a => a.examquestion_id === questionId);
            return ans && ans.score !== null ? Number(ans.score) : 0;
          };

          this.examQuestions.forEach((ques) => {
            // Skip subquestions (handled in main/sub logic)
            if (ques.subquestion_parent_id !== null) return;

            // OR question logic
            if (ques.orquestion_group_id !== null) {
              const groupId = ques.orquestion_group_id;

              if (!orQgroupIds.includes(groupId)) {
                orQgroupIds.push(groupId);

                // Get all main questions in this OR group (excluding subquestions)
                let groupQuestions = this.examQuestions.filter(q =>
                  q.orquestion_group_id === groupId &&
                  q.subquestion_parent_id === null
                );

                let scoreList = [];

                groupQuestions.forEach(groupQ => {
                  // If groupQ has subquestions, sum scores of subquestions
                  if (this.examQuestions.some(q => q.subquestion_parent_id === groupQ.id)) {
                    let subQs = this.examQuestions.filter(q => q.subquestion_parent_id === groupQ.id);
                    let subScore = subQs.reduce((sum, sub) => sum + getScore(sub.id), 0);
                    scoreList.push(subScore);
                  } else {
                    // No subquestions, take score directly
                    scoreList.push(getScore(groupQ.id));
                  }
                });

                // Sort scores and pick best of N
                scoreList.sort((a, b) => b - a);
                let bestOf = this.orquestiongroups[groupId]?.best_of_questions || scoreList.length;
                this.totalScore += scoreList.slice(0, bestOf).reduce((a, b) => a + b, 0);
              }

            } else {
              // Not OR grouped
              if (this.examQuestions.some(q => q.subquestion_parent_id === ques.id)) {
                // Main question with subquestions
                let subQs = this.examQuestions.filter(q => q.subquestion_parent_id === ques.id);
                subQs.forEach(subq => {
                  this.totalScore += getScore(subq.id);
                });
              } else {
                // Normal single question
                this.totalScore += getScore(ques.id);
              }
            }
          });

          if (this.exam.max_co_scores != null) {
            this.getParticipantCoScore();
          }
          this.StudentExamSheet = false;
          this.fetchData = false;
          // if (this.studentSheet.length == 0) {
          //   setTimeout(() => {
          //     this.closeCurrentTab();
          //   }, 5000);
          // }

        })
        .catch((error) => {
          error;
        });
    },
    async getExamQuestions() {
      this.StudentExamSheet = true;
      await this.getOrquestionGroups();
      const url =
        this.$store.getters.getAPIKey.examination + `/${this.exam.id}/examquestions?from_view_score=${true}`;
      await axios
        .get(url)
        .then((response) => {
          this.examQuestions = [];
          this.studentSheet = [];
          this.examQuestions = response.data;

          if (this.examQuestions.length != 0) {
            this.mainQnIds = [];
            let orQgroupIds = [];
            this.maxScore = 0;

            this.examQuestions.forEach((ques) => {
              let qChoices = {};
              if (ques.choices.length > 0) {
                ques.choices.forEach(choice => {
                  qChoices[choice.id] = choice;
                });
              }

              this.studentSheet.push({
                questionId: ques.id,
                studentId: "",
                questionNumber: ques.question_no,
                question: ques.name,
                maximum_mark: ques.maximum_mark,
                answer: "",
                marks: "",
                attachment: [],
                files: ques.files,
                studentFiles: [],
                subquestion_parent_id: ques.subquestion_parent_id,
                orquestion_group_id: ques.orquestion_group_id,
                choices: qChoices,
                choice_id: null
              });

              if (ques.subquestion_parent_id != null) {
                if (!this.mainQnIds.includes(ques.subquestion_parent_id)) {
                  this.mainQnIds.push(ques.subquestion_parent_id);
                }
                return;
              }

              if (ques.orquestion_group_id != null) {
                if (!orQgroupIds.includes(ques.orquestion_group_id)) {
                  orQgroupIds.push(ques.orquestion_group_id);
                  let groupQuestions = this.examQuestions.filter(q =>
                    q.orquestion_group_id === ques.orquestion_group_id &&
                    q.subquestion_parent_id == null
                  );

                  let scoreList = [];
                  groupQuestions.forEach(groupQ => {
                    if (this.examQuestions.some(q => q.subquestion_parent_id === groupQ.id)) {
                      let subs = this.examQuestions.filter(q => q.subquestion_parent_id === groupQ.id);
                      let subSum = subs.reduce((sum, sub) => sum + Number(sub.maximum_mark), 0);
                      scoreList.push(subSum);
                    } else {
                      scoreList.push(Number(groupQ.maximum_mark));
                    }
                  });

                  scoreList.sort((a, b) => b - a);
                  let bestOf = this.orquestiongroups[ques.orquestion_group_id].best_of_questions;
                  let bestScores = scoreList.slice(0, bestOf);
                  this.maxScore += bestScores.reduce((a, b) => a + b, 0);
                }
              } else {
                if (this.examQuestions.some(q => q.subquestion_parent_id === ques.id)) {
                  let subs = this.examQuestions.filter(q => q.subquestion_parent_id === ques.id);
                  subs.forEach(subq => {
                    this.maxScore += Number(subq.maximum_mark);
                  });
                } else {
                  this.maxScore += Number(ques.maximum_mark);
                }
              }
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });

      this.getStudentSheet();
    },

    clearResponse() {
      this.marksBtn.text = "Submit";
      setTimeout(() => {
        this.getExamQuestions();
        this.marksBtn.disabled = false;
      }, 3000);
    },
  },
  watch: {
    studentSheet: {
      deep: true,
      handler: async function () {
        let answerMarks;
        // if (this.studentSheet.length != 0) {
        await this.studentSheet.forEach((mark) => {
          // if (mark.marks == "") {
          //   this.currentMark = "0";
          // }
          if (mark.marks != "") {
            answerMarks = mark.marks;
          }
        });
        if (answerMarks != undefined) {
          this.currentMark = this.currentMark + answerMarks;
        }

        // }
      },
    },
  },
};
</script>

<style>
.evaluate .col-md-12 {
  height: 600px;
  overflow-y: scroll;
}

.coScore-table {
  width: 100%;
}

.coScore-table table,
th,
td {
  border: 1px solid;
}
</style>
